/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { TabContent, TabPane, Nav, NavItem, NavLink, Button, 
  Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import classnames from 'classnames';

import UserProperties from './UserProperties.js'
import UserPermissions from './UserPermissions.js'
import UserLoginHistory from './UserLoginHistory.js'

class UserAdminModal extends React.Component
{

  closing = false;
  tabTypes = null;
  refreshRequired = false;

  constructor(props)
  {
    super();

    this.state =
    {
      tabIndex: 0
    }

    this.setRefreshRequired = this.setRefreshRequired.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  render()
  {
    this.tabTypes = ['properties', 'permissions', 'loginHistory'];

    let navElement = 
    (
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: this.state.tabIndex === 0 })} onClick={() => { this.toggleTab(0); }} >
            Properties
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: this.state.tabIndex === 1 })} onClick={() => { this.toggleTab(1); }} >
            Permissions
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: this.state.tabIndex === 2 })} onClick={() => { this.toggleTab(2); }} >
            Login History
          </NavLink>
        </NavItem>
      </Nav>
    );

    let tabContentElement =
    (
      <TabContent activeTab={this.state.tabIndex}>
        <TabPane tabId={0}>
          <UserProperties username={this.props.rowInfo.username} setRefreshRequired={this.setRefreshRequired} />
        </TabPane>
        <TabPane tabId={1}>
          <Row>
            <Col sm="12">
              { ( 1 === this.state.tabIndex && <UserPermissions username={this.props.rowInfo.username} /> ) }
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId={2}>
          <Row>
            <Col sm="12">
              { 2 === this.state.tabIndex && <UserLoginHistory username={this.props.rowInfo.username} /> }
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId={3}>
          <Row>
            <Col sm="12">
              Data Usage....
            </Col>
          </Row>
        </TabPane>
      </TabContent>
    );

    return(
      <Modal className="modal-lg" isOpen={this.props.modalIsOpen} toggle={this.toggleModal} autoFocus={false} >
        <ModalHeader toggle={(e) => {this.toggleModal(e)}}>User Details: {this.props.rowInfo.username}</ModalHeader>
        <ModalBody>
          {navElement}
          {tabContentElement}
        </ModalBody>
        <ModalFooter>
          <Button className="float-right" color="secondary" onClick={this.toggleModal}>OK</Button>
        </ModalFooter>
      </Modal>
    );
  }

  setRefreshRequired()
  {
    this.refreshRequired = true;
  }

  toggleModal(event)
  {
    if (this.closing) return;

    this.closing = true;
    this.props.onClose(event, this.refreshRequired);
  }

  toggleTab(tabIndex)
  {
    if (this.state.tabIndex !== tabIndex)
    {
      this.setState({ tabIndex: tabIndex });
    }
  }
}

export default UserAdminModal